'use client';

import { GeoLocation } from '@/shared/utils/geo-location/geo-location.type';

export async function getGeoLocationOnClient(): Promise<GeoLocation | null> {
  try {
    const response = await fetch('/api/geolocation');
    if (!response.ok) return null;
    return (await response.json()) as GeoLocation;
  } catch {
    return null;
  }
}
